import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, autorun } from 'mobx';
import Modal from '../Modal';
import Spinner from '../Spinner';
import Form, { FormBody, FormActions, SelectInput, TextInput } from '../Form';

@inject('userStore', 'roleStore')
@observer
class UserAdd extends Component {
  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };

  static propTypes = {
    route: PropTypes.shape().isRequired,
  };

  @observable user = {
    name: '',
    username: '',
    designation: '',
    role_id: 1,
  };
  @observable roles = [];

  slug = '/user';
  title = 'Add User';
  dispose = null;

  constructor(props) {
    super(props);

    this.onChangeName = this.onChange.bind(this, 'name');
    this.onChangeUsername = this.onChange.bind(this, 'username');
    this.onChangeDesignation = this.onChange.bind(this, 'designation');
    this.onChangeRole = this.onChange.bind(this, 'role_id');
    this.onChangeEmail = this.onChange.bind(this, 'email');
    this.onChangeMobile = this.onChange.bind(this, 'mobile');
    this.handleSave = this.handleSave.bind(this);
  }

  componentWillMount() {
    const { roleStore } = this.props;
    roleStore.fetchItems();

    this.dispose = autorun(() => {
      const foundRoles = roleStore.items.toJS();
      this.reset(foundRoles);
    });
  }

  componentWillUnmount() { this.dispose(); }

  @action reset(foundRoles) {
    if (foundRoles) { this.roles = foundRoles; }
  }

  onChange(field, event) {
    this.user = {
      ...this.user,
      [field]: event.target.value,
    };
  }

  handleSave(e) {
    e.preventDefault();

    const { userStore } = this.props;
    const {notify} = this.context;
    userStore.createItem(this.user).then(notify.success).catch(notify.error);
    this.context.router.push(this.slug);
  }

  render() {
    const { userStore } = this.props;
    const {
      name = '',
      username = '',
      designation = '',
    } = this.user;

    if (userStore.isSpinner) { return <Spinner />; }

    return (
      <Modal title={this.title} slug={this.slug} isSaving={userStore.isSaving} handleSave={this.handleSave}>
        <Form>
          <FormBody>
            <TextInput label={'Username'} value={username} onChange={this.onChangeUsername} />
            <TextInput label={'Name'} value={name} onChange={this.onChangeName} />
            <TextInput label={'Designation'} value={designation} onChange={this.onChangeDesignation} />

            <SelectInput
              label={'Role'}
              fields={{ label: 'name', value: 'id' }}
              options={this.roles}
              onChange={this.onChangeRole}
              value={this.user.role_id}
            />
            <TextInput label={'Email'} value={this.user.email} onChange={this.onChangeEmail} />
            <TextInput label={'Mobile No.'} value={this.user.mobile} onChange={this.onChangeMobile} />
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}


export default UserAdd;



// WEBPACK FOOTER //
// ./src/components/User/UserAdd.js